import React, { useState } from "react";
import { Breadcrumb, Title, ResearchCard } from "../components";

import { researchs } from "../assets/data/data";
// import axios from "axios";

const Research = () => {
  // const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [status, setStatus] = useState("Research Project");
  // const [next, setNext] = useState({
  //   page: 1,
  //   limit: 2,
  // });
  // const [ielts, setIelts] = useState([]);
  // const [count, setCount] = useState(0);
  // useEffect(() => {
  //   const Fun = async () => {
  //     try {
  //       const res = await axios.get(
  //         `${SERVER_URL}ielts/count`,
  //         next
  //         // TOKEN
  //       );
  //       if (res.status === 200) {
  //         setCount(res.data);
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };
  //   Fun();
  //   // eslint-disable-next-line
  // }, []);
  // useEffect(() => {
  //   const Fun = async () => {
  //     try {
  //       const res = await axios.get(
  //         `${SERVER_URL}ielts?page=${next.page}&limit=${next.limit}`,
  //         next
  //       );
  //       if (res.status === 200) {
  //         setIelts([...ielts, ...res.data]);
  //         setNext({ ...next, page: next.page + 1 });
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };
  //   Fun();
  //   // eslint-disable-next-line
  // }, [next]);
  const filteredResearchs = researchs.filter(
    (res) => res.type.toLowerCase() === status.toLowerCase()
  );
  // console.log(research);
  // Filter funksiyasi yaratamiz, type ni takrorlanmas qilib olish
  const filterTypes = (arr) => {
    return arr.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t) => t.type.toLowerCase() === value.type.toLowerCase())
    );
  };
  // Natijani olish
  const uniqueResearchTypes = filterTypes(researchs);
  return (
    <div className="container">
      <Breadcrumb current="Research" />
      <Title title="Tadqiqodlar" subtitle="find the right course for you" />
      <section className="courses my-0 ">
        <div className="row justify-content-center">
          <div className="col-12">
            <nav>
              <div
                className="nav nav-tabs mb-4 border-0 justify-content-center "
                id="nav-tab"
                role="tablist"
              >
                {uniqueResearchTypes.map((item, index) => (
                  <button
                    className={`nav-link ${
                      index == 0 ? "active" : ""
                    } rounded-3 me-2 px-4 mb-2 mb-md-0`}
                    onClick={() => setStatus(item.type)}
                    data-bs-toggle="tab"
                  >
                    {item.type}
                  </button>
                ))}
              </div>
            </nav>
            <div className="tab-content " id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="ielts"
                role="tabpanel"
                aria-labelledby="ielts-tab"
              >
                <div className="row justify-content-center g-4 ">
                  {filteredResearchs.map((item) => (
                    <ResearchCard key={item.id} {...item} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12"></div>
        </div>
      </section>
    </div>
  );
};

export default Research;
